// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  apiBaseUrl:'https://uat.theworldwidecard.net/v2',
  apiBaseUrl3:'https://uat.theworldwidecard.net',
  loginAPIUrl: 'https://uat.theworldwidecard.net/api/v1.0',
  apiBaseUrl2:'https://xabits.com/app',
  pgAPIUrl:'https://dev-ob1epin.herokuapp.com/api',
  pgUrlNew:'https://dev-ob1epin.herokuapp.com',
  pgAPIUrl1:'https://dev-ob1epin.herokuapp.com/api',
  pgUrlNew1:'https://dev-ob1epin.herokuapp.com',
  setHeaderToken:true
};
